/**
 * Random id generator.
 * Note randomId should not be set as a default state
 * https://bitbucket.wolterskluwer.io/projects/ELEMENTS/repos/cogen/pull-requests/915/overview
 */
export function randomId() {
    return 'i' + (Number(Math.random().toString().slice(2))).toString(36);
}
